"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserTypingWrapper = exports.UserTyping3 = exports.UserTyping2 = exports.UserTyping1 = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var UserTypingWrapper = exports.UserTypingWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var userTyping1Frame = (0, _styledComponents.keyframes)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {opacity: var(--opacity-none);}\n  25% {opacity: var(--opacity-full);}\n  50% {opacity: var(--opacity-full);}\n  75% {opacity : var(--opacity-full);}\n  100% {opacity: var(--opacity-none);}\n"])));
var UserTyping1 = exports.UserTyping1 = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 8px;\n  height: 8px;\n  background-color: var(--color-neutral-110);\n  border-radius: 4px;\n  animation-name: ", ";\n  animation-duration: 1s;\n  animation-iteration-count: var(--transition-repetition-infinite);\n"])), userTyping1Frame);
var userTyping2Frame = (0, _styledComponents.keyframes)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  0% {opacity: var(--opacity-none);}\n  25% {opacity: var(--opacity-none);}\n  50% {opacity: var(--opacity-full);}\n  75% {opacity : var(--opacity-full);}\n  100% {opacity: var(--opacity-none);}\n"])));
var UserTyping2 = exports.UserTyping2 = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 8px;\n  height: 8px;\n  background-color: var(--color-neutral-110);\n  border-radius: 4px;\n  animation-name: ", ";\n  animation-duration: 1s;\n  animation-iteration-count: var(--transition-repetition-infinite);\n"])), userTyping2Frame);
var userTyping3Frame = (0, _styledComponents.keyframes)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  0% {opacity: var(--opacity-none);}\n  25% {opacity: var(--opacity-none);}\n  50% {opacity: var(--opacity-none);}\n  75% {opacity : var(--opacity-full);}\n  100% {opacity: var(--opacity-none);}\n"])));
var UserTyping3 = exports.UserTyping3 = _styledComponents["default"].span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 8px;\n  height: 8px;\n  background-color: var(--color-neutral-110);\n  border-radius: 4px;\n  animation-name: ", ";\n  animation-duration: 1s;\n  animation-iteration-count: var(--transition-repetition-infinite);\n"])), userTyping3Frame);